(function () {
    "use strict";

    //set up to autoplay the first video//
    const videoWrappers = document.querySelectorAll(".inline-video-2-column");

    videoWrappers.forEach((wrapper) => {
        const videoPlayer = wrapper.querySelector(".js-video-iframe");

        const videoDate = wrapper.querySelector(".js-video-date");

        const videoTitle = wrapper.querySelector(".js-video-title");
        const videoDescription = wrapper.querySelector(".js-video-description");
        const videoLink = wrapper.querySelector(".js-video-link");
        const videoTranscript = wrapper.querySelector(".js-video-transcript");

        const buttons = wrapper.querySelectorAll(".js-video-btn");

        buttons.forEach((button) => {
            const isActive = button.classList.contains("active");
            button.setAttribute("aria-pressed", isActive ? "true" : "false");
            const { src, date, description, link, transcript } = button.dataset;
            const title = button.querySelector(".js-video-title").textContent;
            button.addEventListener("click", async function (event) {
                const target = event.currentTarget;
                if (target.classList.contains("active")) {
                    return;
                }
                buttons.forEach((btn) => {
                    btn.classList.remove("active");
                    btn.setAttribute("aria-pressed", "false");
                });
                target.classList.add("active");
                target.setAttribute("aria-pressed", "true");

                videoPlayer.src = `${src}?autoplay=1`;
                videoDate.textContent = `Updated ${date}`;
                videoTitle.textContent = title;
                videoDescription.textContent = description;
                videoLink.href = link;

                try {
                    const response = await fetch(transcript);
                    const html = await response.text();
                    if (response.ok) {
                        videoTranscript.innerHTML = html;
                    } else {
                        throw new Error(`Failed to fetch ${transcript}`);
                    }
                } catch (error) {
                    console.error(error);
                    videoTranscript.innerHTML = `<p><a href="${transcript}" target="_blank" class="inline-video__cta-btn">Read transcript</a></p>`;
                }
            });
        });
    });
})();
